import styled from "@emotion/styled";
import { Box } from "@mui/material";


export const ChartContain = styled(Box)(()=>({
    height: '140px',
    overflow:'hidden',
    display: 'flex',
    justifyContent: 'end',
}))